import React from 'react'
import AsyncTableListing from '../../ui-components/AsyncTableListing'
import BreadcrumbHeader from '../../layout/BreadcrumbsHeader'
import ThemeBGWrapper from '../../ui-components/ThemeBGWrapper'
import { useTheme } from '@emotion/react'
import { ReactComponent as RoundDetailsIcon } from "assets/rounds_icons/round_details_icon.svg"
import { Autocomplete, Box, Grid, IconButton, Menu, MenuItem, Stack, Tooltip, useMediaQuery } from '@mui/material'
import { ReactComponent as Subscription } from '../../assets/nav_icons/crown-svgrepo-com.svg';
import CustomTabs from '../../ui-components/CustomTabs'
import { TabContext } from '@mui/lab'
import { Add, AttachMoneyOutlined, Block, CancelRounded, ChecklistRtl, Close, Cookie, Description, DoneAll, DoneRounded, FiberNew, FiberNewRounded, FileUpload, FilterAltOutlined, FilterAltRounded, LanguageOutlined, LinkedIn, More, NewReleasesOutlined, Notes, OpenInNew, Public, PublishedWithChanges, RateReview, RocketLaunch, Rule, Search, SkipNext, ThumbDown, ThumbUp, VerifiedUser, VpnKey, VpnKeyOutlined } from '@mui/icons-material'
import { makeStyles } from '@mui/styles'
import { amountInWords, getFileIcon, handleCopyClick, hasPermission, singleSignOn, source_list } from '../../utils'
import { Link, useNavigate } from 'react-router-dom'
import CustomInputField from 'ui-components/CustomInputField'
import { B400 } from 'ui-components/CustomButton';
import { Primary } from 'ui-components/Buttons';import { ReactComponent as MoreOptionsIcon } from "assets/rounds_icons/more_solid_icon.svg";
import NeedHelpButton from 'ui-components/NeedHelpButton'
import FilterPopup from "./popups/FilterPopup"
import ModalComponent from 'ui-components/ModalComponent'
import FeedbackPopup from './popups/FeedbackPopup'
import ShowInterestPopup from './popups/ShowInterestPopup'
import OnboardedConfirmationPopup from "ui-components/popups/ConfirmationPopup"
import RejectedConfirmationPopup from "ui-components/popups/ConfirmationPopup"
import RequestDocumentsPopup from "ui-components/popups/ConfirmationPopup"
import Cookies from 'js-cookie'
import { FetchAllCategories, FetchAllStages, FetchAllSubCategories } from 'api/utils'
import { UpdateStartupStatus, MoveStartupToOnboarded, GenerateUserTokenByAdminOnly, DeleteStartupByID, SubscriptionDeactivatedByAdmin } from 'api/backrr_startups'
import InviteStartupPopup from './popups/InviteStartupPopup'
import { useSelector } from 'react-redux'
import { FetchAllStartupsListing, FetchInterestFeedbackStatus, InviteStartupPOST, SaveFeedback, SaveInterest } from 'api/backrr_startups'
import PDFView from './popups/PDFView'
import CustomToast from 'ui-components/CustomToast'
import AlertDialog from 'ui-components/popups/AlertPopup'
import toast from 'react-hot-toast'
import { ReactComponent as AnalyticsIcon } from '../../assets/nav_icons/rocket_1.svg';
import placeHolderImage from "assets/no_data_images/BackrrStartups/no_data_feedbacks_views.svg"
import { useToast } from 'context/ToastContext'
import DeleteConfirmationDialog from 'ui-components/popups/DeleteConfirmationPopup'
import CreateSubscription from './popups/CreateSubscription'
import ConfirmationPopup from 'ui-components/popups/ConfirmationPopup'
import moment from 'moment'
import EmailBounceCell from 'common-components/EmailBounceCell'
import UpdateEmailPopup from 'ui-components/popups/UpdateEmailPopup'
const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        "&": {
            padding: "3rem"
        }
        // '& .MuiTabs-root > .MuiTabs-scroller > .MuiTabs-flexContainer' : {marginLeft: '2rem', gap: '5rem'}
    }
    //     '& .MuiTabs-root > .Mui-disabled.MuiTabs-scrollButtons': {
    //         display: 'none !important',
    //         transition: 'all 1s ease'
    //     },
    // }
}));

const StartupsListing = () => {
    const paginationCookie = "backrr_startups_page";
    const { addToast } = useToast();
    const userPermissions = useSelector(state => state?.permissions?.userPermissions) || null;
    const theme = useTheme();
    const classes = useStyles();
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state?.investorDetails?.data);
    const investor_id = Cookies.get("X-ADMIN-ID") || null;
    const currentIP = window.location.host;

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const startupTabs = [
        { value: "all", label: 'All', count: 10, read: false, icon: RocketLaunch },
        { value: "in_progress", label: 'In-Progress', count: 10, read: false, icon: DoneAll },
        { value: "on_boarded", label: 'On-Boarded', count: 10, read: false, icon: FileUpload },
        { value: "in_complete", label: 'Incomplete', count: 10, read: false, icon: Close },
        { value: "subscribed", label: 'Subscribed', count: 10, read: false, icon: Subscription },
        // { value: "pitch_deck", label: 'Via Pitch Deck', count: 10, read: false, icon: FileUpload },
        // { value: "dashboard", label: 'Via Dashboard', count: 10, read: false, icon: SkipNext },
        // { value: "investor_profile", label: 'Via Investor Profile', count: 10, read: false, icon: Public },
    ]
    const [page, setPage] = React.useState(Number(Cookies.get(paginationCookie)) || 1);
    const [limit, setLimit] = React.useState(10);
    const parsedCookieForQueryParams = Cookies.get("backrr_startups_query") ? JSON.parse(Cookies.get("backrr_startups_query")) : {}
    const [queryParams, setQueryParams] = React.useState(parsedCookieForQueryParams);
    const [stage, setStage] = React.useState(null);
    const [category, setCategory] = React.useState(null);
    const [sector, setSector] = React.useState(null);
    const [profileSource, setProfileSource] = React.useState(null);
    const [profileProgress, setProfileProgress] = React.useState(null);
    const [locationFilter, setLocationFilter] = React.useState(null);
    const parsedCookieForStatus = Cookies.get("backrr_startups_status") || "all"
    const [value, setValue] = React.useState(parsedCookieForStatus || "all")
    const [search, setSearch] = React.useState("" || Cookies.get("search_backrr_startups"));
    const [reset, setReset] = React.useState(false);
    const [searchStatus, setSearchStatus] = React.useState(Object.keys(parsedCookieForQueryParams)?.length > 0 || search?.length > 0 || false);
    const [openFilter, setOpenFilter] = React.useState(false);
    const { data: transformedData, isRefetching: isRefetchingStartupListing, isLoading: isLoadingStartupListing, refetch: refetchListing } = FetchAllStartupsListing({ page, limit, status: value, queryParams, searchText: search })
    const { data: startup_stages, isRefetching: isRefetchingAllStages, isLoading: isLoadingAllStages, refetch: refetchAllStages } = FetchAllStages();
    const { data: startup_categories, isRefetching: isRefetchingAllCategories, isLoading: isLoadingAllCategories, refetch: refetchAllCategories } = FetchAllCategories();
    const { data: startup_sub_categories, isRefetching: isRefetchingAllSubcategories, isLoading: isLoadingAllSubcategories, refetch: refetchAllSubcategories } = FetchAllSubCategories({ category: queryParams?.category });
    const {
        mutateAsync: FetchStatusAsync,
        status: fetchStatusStatus,
        error: fetchStatusError,
        isLoading: isUpdatingFetchStatus,
        data: fetchStatusResponse,
    } = FetchInterestFeedbackStatus();
    const [isEnabledInterest, setIsEnabledInterest] = React.useState(false);
    const [isEnabledFeedback, setIsEnabledFeedback] = React.useState(false);
    const [showAlert, setShowAlert] = React.useState(false)
    const [alertMessage, setAlertMessage] = React.useState(null)
    const [alertHeading, setAlertHeading] = React.useState(null)

    // console.log(transformedData?.data, "startupListingData")
    const handleTabChange = (event, newValue) => {
        // console.log("value", newValue)
        setValue(newValue);
        Cookies.set("backrr_startups_status", newValue);
        setPage(1);
        Cookies.set(paginationCookie, 1);
        newValue === "subscribed" && Cookies.remove("backrr_startups_query")
        // newValue === "subscribed" && Cookies.remove("search_backrr_startups")
        newValue === "subscribed" && setQueryParams({})
        // newValue === "subscribed" && setSearch("")
        // newValue === "subscribed" && setSearchStatus(false)
    };

    const {
        mutateAsync: provideSSOtoAdminAsync,
        status: provideSSOtoAdminStatus,
        error: provideSSOtoAdminError,
        isLoading: isLoadingSSOToken,
        data: provideSSOtoAdminResponse,
    } = GenerateUserTokenByAdminOnly();

    const {
        mutateAsync: deleteStartupAsync,
        status: deleteStartupStatus,
        error: deleteStartupError,
        isLoading: isDeletingStartupToken,
        data: deleteStartupResponse,
    } = DeleteStartupByID();


    const {
        mutateAsync: deactivateSubscriptionAsync,
        status: deactivateSubscriptionStatus,
        error: deactivateSubscriptionError,
        isLoading: isDeactivatingSubscription,
        data: deactivateSubscriptionResponse,
    } = SubscriptionDeactivatedByAdmin();

    const [openActivateSubscriptionPopup, setOpenActivateSubscriptionPopup] = React.useState(false);

    // Row whose email is being corrected (e.g. after a bounce); null when closed
    const [emailUpdateRow, setEmailUpdateRow] = React.useState(null);

    const [openDeactivateSubscriptionPopup, setOpenDeactivateSubscriptionPopup] = React.useState(false);

    const handleCloseActivateSubscription = () => {
        setOpenActivateSubscriptionPopup(false);
        setCurrentRow(null);
    }

    const handleCloseDeactivateSubscription = () => {
        setOpenDeactivateSubscriptionPopup(false);
        setCurrentRow(null);
    }

    const handleDeactivateSubscription = (props) => {
        // console.log("Deactivating subscription for:", props);
        deactivateSubscriptionAsync({ startup_id: props?.row?._id })?.then((response) => {
            if (response?.data?.statusCode === 200) {
                refetchListing()
                handleCloseDeactivateSubscription()
                addToast("Subscription Deactivated!", "success")
            }
            else {
                addToast("Error: Something went wrong.", "error")
            }
        })
    }

    const RowActions = ({ row, iconsColor = theme.palette.customColors.indigo700, index }) => {
        // return <>

        // </>
        // console.log(row, "row")

        const [anchorEl, setAnchorEl] = React.useState(null);
        const openMenu = Boolean(anchorEl);
        const handleClickMenu = (event, index) => {
            setAnchorEl(event.currentTarget);
            // setCurrentIndex(index)
            // console.log(event.currentTarget,"re")
        };
        const handleCloseMenu = (event) => {
            // console.log(event,"event")
            setAnchorEl(null);
            // setCurrentIndex(null);
        };

        const [showDeletePopup, setShowDeletePopup] = React.useState(false);

        const handleOpenDeletePopup = () => {
            setShowDeletePopup(true);
        }

        const handleCloseDeletePopup = () => {
            setShowDeletePopup(false);
        }

        const handleDeleteStartup = () => {
            // console.log(currentRow?._id,"ddd")
            //   deleteUserDataAsync({ user_id: currentRow?._id }, {
            //     onSuccess: () => {
            //       refetchVersionsData();
            //       handleCloseDeletePopup();
            //       toast.success(toast_message?.users?.delete)
            //     },
            //     onError: () => {
            //     }
            //   })
            deleteStartupAsync({ startup_id: row?.original?._id })?.then((response) => {
                // window.open("http://localhost:3001/cHJpdmF0ZS1yb3V0ZQ==?access-token=" + response?.data?.token, '_blank', 'incognito');
                // console.log(response?.data?.statusCode, "data");
                if (response?.data?.statusCode === 200) {
                    refetchListing()
                    handleCloseDeletePopup()
                    // toast.success("Startup Deleted!")
                    addToast("Startup Deleted!", "success")
                    // window.open(singleSignOn(currentIP, "startup") + "/cHJpdmF0ZS1yb3V0ZQ==?access-token=" + response?.data?.token, "_blank");
                }
                else {
                    addToast("Error: Something went wrong.", "error")
                    // toast.error("Error: Something went wrong.")
                }

            })
        }

        // switch (value) {
        //     case "new": return <>
        return <>
            <DeleteConfirmationDialog open={showDeletePopup} handleClose={handleCloseDeletePopup} handleSubmission={handleDeleteStartup} heading={"Delete Startup"} ActionText={"Confirm"} subheading={"Are you sure you want to delete this startup?"} />
            {row?.original?.backrr_base_url && row?.original?.backrr_base_url != null && (String(row?.original?.backrr_base_url)?.length > 0) && <Tooltip title="View Profile">
                <IconButton centerRipple={false} sx={{ borderRadius: "4px", color: theme.palette.customColors.indigo600 }} onClick={() => {
                    window.open(row?.original?.backrr_base_url);
                }}>
                    <OpenInNew fontSize='1.5rem' />
                </IconButton>
            </Tooltip>
            }
            {row?.original?.email &&
                <Tooltip title="Single Sign-On (SSO)">
                    <IconButton sx={{ borderRadius: "4px", color: theme.palette.customColors.indigo600 }} centerRipple={false} onClick={() => {
                        if (row?.original?._id && row?.original?.email) {
                            provideSSOtoAdminAsync({ payload: { email: row?.original?.email } })?.then((response) => {
                                if (response?.data?.statusCode === 200) {
                                    window.open(singleSignOn(currentIP, "startup") + "/cHJpdmF0ZS1yb3V0ZQ==?access-token=" + response?.data?.token, "_blank");
                                }
                                else {
                                    addToast("User Not Found", "error")
                                    // toast.error("User Not Found")
                                }
                                // handleCloseMenu(e)
                            })
                        }
                    }}>
                        <VpnKey fontSize='1.5rem' />
                    </IconButton>
                </Tooltip>
            }
            {row?.original?.email &&
                <Tooltip title="Copy Upgrade Link">
                    <IconButton sx={{ borderRadius: "4px", color: theme.palette.customColors.indigo600 }} centerRipple={false} onClick={() => {
                        if (row?.original?._id && row?.original?.email) {
                            provideSSOtoAdminAsync({ payload: { email: row?.original?.email } })?.then((response) => {
                                if (response?.data?.statusCode === 200) {
                                    handleCopyClick(singleSignOn(currentIP, "startup") + "/cHJpdmF0ZS1yb3V0ZQ==?access-token=" + response?.data?.token + "&redirect=upgrade", true, () => { });
                                }
                                else {
                                    addToast("User Not Found", "error")
                                    // toast.error("User Not Found")
                                }
                                // handleCloseMenu(e)
                            })
                        }
                    }}>
                        <AttachMoneyOutlined fontSize='1.5rem' />
                    </IconButton>
                </Tooltip>
            }
            {/* Show Activate Subscription button when no subscription plan exists */}
            {row?.original?._id && (value === "subscribed" ? false : !row?.original?.subscription?.plan) &&
                <Tooltip title="Activate Subscription">
                    <IconButton sx={{ borderRadius: "4px", color: theme.palette.customColors.indigo600 }} centerRipple={false} onClick={() => {
                        if (row?.original?._id) {
                            setCurrentRow(row?.original);
                            setOpenActivateSubscriptionPopup(true);
                        }
                    }}>
                        <VerifiedUser fontSize='1.5rem' />
                    </IconButton>
                </Tooltip>
            }
            {/* Show Deactivate Subscription button when subscription plan exists */}
            {row?.original?._id && (value === "subscribed" ? true : row?.original?.subscription?.plan) &&
                <Tooltip title="Deactivate Subscription">
                    <IconButton sx={{ borderRadius: "4px", color: theme.palette.customColors.indigo600 }} centerRipple={false} onClick={() => {
                        if (row?.original?._id) {
                            setCurrentRow(row?.original);
                            setOpenDeactivateSubscriptionPopup(true);
                        }
                    }}>
                        <Block fontSize='1.5rem' />
                    </IconButton>
                </Tooltip>
            }
            <IconButton
                sx={{ borderRadius: "4px" }}
                id={`more-details-button-${index}`}
                size="medium"
                aria-controls={openMenu ? 'more-details-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : undefined}
                onClick={(e) => handleClickMenu(e)}
                centerRipple={false}
            >
                <MoreOptionsIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : 'false'}
                onClose={handleCloseMenu}
                // onClick={handleCloseMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        padding: "12px",
                        borderRadius: "8px",
                        "& > ul.MuiList-root": { padding: "0 !important" },
                        bgcolor: theme.palette.customColors.g400,
                        color: theme.palette.customColors.whiteBG,
                        // '&::before': {
                        //     content: '""',
                        //     display: 'block',
                        //     position: 'absolute',
                        //     top: 1,
                        //     right: 5,
                        //     width: 10,
                        //     height: 10,
                        //     bgcolor: theme.palette.customColors.g900,
                        //     transform: 'translateY(-50%) rotate(45deg)',
                        //     zIndex: 0,
                        // },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'center' }}
            >
                <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={(e) => {
                    // if (row?.original?._id) {
                    //     Cookies.set("startup_id", row?.original?._id);
                    //     handleCloseMenu(e)
                    //     navigate(location ? `view-profile` : `backrr_startups/view-profile`)
                    // }
                    if (row?.original?._id) {
                        navigate(`/backrr_startups/view-profile?startup_id=${row?.original?._id}`);
                    }
                }}>
                    View Details
                </MenuItem>
                {/* {row?.original?.backrr_base_url && row?.original?.backrr_base_url != null && (String(row?.original?.backrr_base_url)?.length > 0) && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={(e) => {
                    window.open(row?.original?.backrr_base_url);
                    handleCloseMenu(e)
                }}>
                    View Profile
                </MenuItem>} */}
                {value === "in_progress" && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={(e) => {
                    if (row?.original?._id) {
                        // Cookies.set("startup_id", row?.original?._id);
                        handleOnboardedConfirmationPopupOpen({ row })
                        handleCloseMenu(e)
                    }
                }}>
                    Move to On-Boarded
                </MenuItem>}
                <MenuItem disableRipple sx={{ borderBottom: `${Boolean(hasPermission("super_admin", "backrr_startups_delete", userPermissions)) ? 1 : 0}px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={(e) => {
                    if (row?.original?._id) {
                        Cookies.set("startup_id", row?.original?._id);
                        handleCloseMenu(e);
                        navigate(location ? `edit` : `backrr_startups/edit`)
                    }
                }}>
                    Edit Profile
                </MenuItem>
                {row?.original?._id && <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={(e) => {
                    handleCloseMenu(e);
                    setEmailUpdateRow(row?.original);
                }}>
                    Update Email
                </MenuItem>}
                {/* {row?.original?.email &&
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={(e) => {
                        if (row?.original?._id && row?.original?.email) {
                            provideSSOtoAdminAsync({ payload: { email: row?.original?.email } })?.then((response) => {
                                if (response?.data?.statusCode === 200) {
                                    window.open(singleSignOn(currentIP, "startup") + "/cHJpdmF0ZS1yb3V0ZQ==?access-token=" + response?.data?.token, "_blank");
                                }
                                else {
                                    addToast("User Not Found", "error")
                                    // toast.error("User Not Found")
                                }
                                handleCloseMenu(e)
                            })
                        }
                    }}>
                        Single Sign-On (SSO)
                    </MenuItem>
                } */}
                {row?.original?._id && Boolean(hasPermission("super_admin", "backrr_startups_delete", userPermissions)) && <MenuItem disableRipple sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }} onClick={(e) => {
                    if (row?.original?._id) {
                        // console.log(row?.original, "rfrf")
                        // console.log(row?.original?.email, "rfrf")
                        handleOpenDeletePopup()
                        handleCloseMenu()
                    }
                }}>
                    Delete
                </MenuItem>}
            </Menu>
        </>
    }

    const NewColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
        { Header: 'Email', accessor: 'email_cell', minWidth: 250, align: 'start' },
        { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
        { Header: 'Profile Source', accessor: 'profile_source', minWidth: 150, align: 'center' },
        { Header: 'Signup Campaign', accessor: 'signup_utm_campaign', minWidth: 150, align: 'center' },
        { Header: 'Signup Source', accessor: 'signup_utm_source', minWidth: 150, align: 'center' },
        { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
        { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
        { Header: 'Created Date', accessor: 'created_date', minWidth: 150, align: 'center' },
        // { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center' },
        { Header: 'Profile Progress', accessor: 'profile_progress', minWidth: 150, align: 'center' },
        { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
        { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'right' }
    ];

    const ShortlistedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
        // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
        { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
        { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
        { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
        { Header: 'Created Date', accessor: 'created_date', minWidth: 150, align: 'center' },
        { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
        { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
        // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'right' }
    ]

    const RejectedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 300, align: 'start', fixed: true },
        // { Header: 'Email', accessor: 'email', minWidth: 150, align: 'start' },
        { Header: 'Location', accessor: 'location', minWidth: 100, align: 'center' },
        { Header: 'Stage', accessor: 'stage', minWidth: 100, align: 'center' },
        { Header: 'Category/Sector', accessor: 'category_sub_sector', minWidth: 100, align: 'center' },
        { Header: 'Created Date', accessor: 'created_date', minWidth: 150, align: 'center' },
        { Header: 'Pitch Deck', accessor: 'pitch_deck', minWidth: 100, align: 'center' },
        { Header: 'Links', accessor: 'links', minWidth: 100, align: 'center' },
        // { Header: 'Funding round', accessor: 'funding_round', minWidth: 100, align: 'center' },
        { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'right' }
    ]

    const columns = value === "new" ? NewColumns : value === "shortlisted" ? ShortlistedColumns : value === "rejected" ? RejectedColumns : NewColumns;

    // Memoized Tooltip Icon Component
    const MemoizedTooltipIcon = React.memo(({ title, icon, onClick }) => (
        <Tooltip title={title}>
            <IconButton onClick={onClick}>{icon}</IconButton>
        </Tooltip>
    ));

    // Memoized Data Transformation
    const useFormattedData = (transformedData) => {
        return React.useMemo(() => {
            return transformedData?.data && transformedData?.data?.length > 0
                ? transformedData?.data?.map((item) => {
                    if (value === "subscribed") {
                        return ({
                            ...item,
                            name: item?.startup_name,
                            subscription_id: item?._id,
                            _id: item?.startup_id,
                            email: item?.email || item?.startup_email,
                            email_cell: <EmailBounceCell email={item?.email || item?.startup_email} bounce={item?.email_bounce} onUpdate={() => setEmailUpdateRow({ ...item, _id: item?.startup_id, email: item?.email || item?.startup_email })} />,
                            image: item?.startup_logo,
                            profile_source: item?.profile_source && source_list ? source_list?.find((item) => {
                                return item?.value === item?.profile_source
                            })?.label : "-",
                            location: item?.city_info ? `${item?.city_info?.name}, ${item?.city_info?.country_name}` : "-",
                            stage: item?.stage_info ? item?.stage_info?.config_values?.name : "-",
                            category_sub_sector:
                                item?.category_info && item?.sector_info
                                    ? `${item?.category_info?.config_values?.name ? item?.category_info?.config_values?.name : "-"} ${item?.sector_info?.config_values && Array.isArray(item?.sector_info?.config_values) && item?.sector_info?.config_values?.length > 0 ? `(${item?.sector_info?.config_values?.map(item => item?.sub_category)})` : "-"}`
                                    : "-",
                            created_date: moment(item?.createdAt)?.format("DD-MMM-YYYY HH:mm:ss"),
                            profile_progress: item?.profile_progress !== undefined && item?.profile_progress !== null ? `${item?.profile_progress}%` : "-",
                            pitch_deck: item?.pitch_deck && !item?.pitch_deck?.includes("undefined") && !item?.pitch_deck?.includes("null") ? (
                                <MemoizedTooltipIcon
                                    title="Pitch Deck"
                                    onClick={() => handleOpenPDFViewer({ row: item })}
                                    icon={<Description sx={{ color: theme.palette.customColors.indigo600 }} />}
                                // icon={<img style={{ width: 20, height: 20 }} src={getFileIcon("pdf")} />}
                                />
                            ) : (
                                <>-</>
                            ),
                            links: (
                                (
                                    (item?.website_url && item?.website_url?.length > 0 || item?.linkedin_url && item?.linkedin_url?.length > 0 || item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id)
                                        ? <Box display="flex" alignItems={"center"} justifyContent={"center"} >
                                            {item?.website_url && item?.website_url?.length > 0 && <MemoizedTooltipIcon
                                                title="Website"
                                                onClick={() => window.open(item?.website_url)}
                                                icon={<LanguageOutlined sx={{ color: theme.palette.customColors.indigo600 }} />}
                                            />
                                            }
                                            {
                                                item?.linkedin_url && item?.linkedin_url?.length > 0 && <MemoizedTooltipIcon
                                                    title="LinkedIn"
                                                    onClick={() => window.open(item?.linkedin_url)}
                                                    icon={<LinkedIn sx={{ color: theme.palette.customColors.indigo600 }} />}
                                                />
                                            }
                                            {
                                                item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id && <MemoizedTooltipIcon
                                                    title="View Round Details"
                                                    onClick={() => {
                                                        if (item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id) {
                                                            Cookies.set("startup_id", item?._id);
                                                            navigate("view-round");
                                                        }
                                                    }}
                                                    icon={<RoundDetailsIcon fill={theme.palette.customColors.indigo600} style={{ width: 20, height: 20 }} />}
                                                />
                                            }
                                        </Box> : '-')
                            )
                        })
                    }
                    return ({
                        ...item,
                        name: item?.startup_name,
                        email: item?.email || item?.startup_email,
                        email_cell: <EmailBounceCell email={item?.email || item?.startup_email} bounce={item?.email_bounce} onUpdate={() => setEmailUpdateRow({ ...item, email: item?.email || item?.startup_email })} />,
                        formatted_interested_amount: Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 ? <Tooltip title={amountInWords(item?.startup_rounds_info[0]?.interested_amount, item?.currency_info ? item?.currency_info[0]?.code : null)}> {item?.startup_rounds_info[0]?.formatted_interested_amount} </Tooltip> : null,
                        location: item?.city && item?.country ? `${item?.city}, ${item?.country}` : "-",
                        profile_source: item?.profile_source && source_list ? source_list?.find((itemEl) => {
                            return itemEl?.value === item?.profile_source
                        })?.label : "-",
                        signup_utm_campaign: item?.signup_utm_campaign || "-",
                        signup_utm_source: item?.signup_utm_source || "-",
                        category_sub_sector: item?.category_info && item?.sector_info
                            ? `${item?.category_info?.name ?
                                item?.category_info?.name
                                : value === "subscribed"
                                    ? item?.category_info :
                                    "-"} ${item?.sector_info ?
                                        (item?.sector_info[0]?.sub_category ? "(" + item?.sector_info[0]?.sub_category + ")" : "(" + item?.sector_info + ")") : "-"}`
                            : "-",
                        stage: item?.stage_info ? (item?.stage_info?.name ? `${item?.stage_info?.name}` : value === "subscribed" ? item?.stage_info : "-") : "-",
                        image: item?.startup_logo_path,
                        profile_progress: item?.profile_progress !== undefined && item?.profile_progress !== null ? `${item?.profile_progress}%` : "-",
                        pitch_deck: item?.pitch_deck_path && !item?.pitch_deck_path?.includes("undefined") && !item?.pitch_deck_path?.includes("null") ? (
                            <MemoizedTooltipIcon
                                title="Pitch Deck"
                                onClick={() => handleOpenPDFViewer({ row: item })}
                                icon={<Description sx={{ color: theme.palette.customColors.indigo600 }} />}
                            // icon={<img style={{ width: 20, height: 20 }} src={getFileIcon("pdf")} />}
                            />
                        ) : (
                            <>-</>
                        ),
                        links: (
                            (
                                (item?.website_url && item?.website_url?.length > 0 || item?.linkedin_url && item?.linkedin_url?.length > 0 || item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id)
                                    ? <Box display="flex" alignItems={"center"} justifyContent={"center"} >
                                        {item?.website_url && item?.website_url?.length > 0 && <MemoizedTooltipIcon
                                            title="Website"
                                            onClick={() => window.open(item?.website_url)}
                                            icon={<LanguageOutlined sx={{ color: theme.palette.customColors.indigo600 }} />}
                                        />
                                        }
                                        {
                                            item?.linkedin_url && item?.linkedin_url?.length > 0 && <MemoizedTooltipIcon
                                                title="LinkedIn"
                                                onClick={() => window.open(item?.linkedin_url)}
                                                icon={<LinkedIn sx={{ color: theme.palette.customColors.indigo600 }} />}
                                            />
                                        }
                                        {
                                            item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id && <MemoizedTooltipIcon
                                                title="View Round Details"
                                                onClick={() => {
                                                    if (item?.startup_rounds_info && Array.isArray(item?.startup_rounds_info) && item?.startup_rounds_info?.length > 0 && item?.startup_rounds_info[0]?._id) {
                                                        Cookies.set("startup_id", item?._id);
                                                        navigate("view-round");
                                                    }
                                                }}
                                                icon={<RoundDetailsIcon fill={theme.palette.customColors.indigo600} style={{ width: 20, height: 20 }} />}
                                            />
                                        }
                                    </Box> : '-')
                        )
                    })
                })
                : [];
        }, [transformedData, value, source_list]);
    };

    let location = window.location.pathname?.includes("startups");

    const StartupLink = React.memo(({ row, children }) => {

        // console.log(row?.original?.startup_rounds_info,"row")
        return (
            <Stack onClick={() => {
                if (row?.original?._id) {
                    navigate(`/backrr_startups/view-profile?startup_id=${row?.original?._id}`);
                }
                //     Cookies.set("startup_id", row?.original?._id);
                //     // console.log(
                //     // window.history.pushState({}, "", "/backrr_startups/view")
                //     // window.History
                //     // ,"history")
                //     navigate(location ? `view-profile` : `backrr_startups/view-profile`)
                // }
            }} style={{ textDecoration: 'none', color: '#616161', fontWeight: 700, cursor: 'pointer' }}>
                {/* <Link to={`view/${row?._id}`} > */}
                {children}
            </Stack>
        )
    })

    const {
        mutateAsync: saveInterestAsync,
        status: saveInterestStatus,
        error: saveInterestError,
        isLoading: isSavingInterest,
        data: saveInterestResponse,
    } = SaveInterest();

    const {
        mutateAsync: saveFeedbackAsync,
        status: saveFeedbackStatus,
        error: saveFeedbackError,
        isLoading: isSavingFeedback,
        data: saveFeedbackResponse,
    } = SaveFeedback();

    const [currentRow, setCurrentRow] = React.useState(null);
    const [selectedPDF, setSelectedPDF] = React.useState('');

    // Cross inside the search field: clears the search term only, filters are
    // reset from the filter popup.
    const handleSearchReset = () => {
        setSearch('');
        Cookies.set("search_backrr_startups", '');
        setSearchStatus(false);
        setPage(1);
        Cookies.set(paginationCookie, 1);
        setReset(!reset);
    }

    const handleFilterOpen = () => {
        setOpenFilter(true);
    }

    const handleFilterClose = () => {
        setOpenFilter(false)
    }

    const handleUpdateFilter = ({ query = {} }) => {
        setQueryParams(query);
        setPage(1);
        Cookies.set(paginationCookie, 1)
        Cookies.set("backrr_startups_query", JSON.stringify(query));
        setSearchStatus(true)
        handleFilterClose();
    }

    const [openFeedbackPopup, setOpenFeedbackPopup] = React.useState(false)
    const [openShowInterestPopup, setOpenShowInterestPopup] = React.useState(false)


    const handleFeedbackPopupOpen = ({ row }) => {
        let request = {
            startup_id: row?.original?.startup_id,
            investor_id: investor_id
        }

        // console.log(request, "row")
        FetchStatusAsync(request).then((response) => {
            // console.log(response,"resssss")
            // setIsEnabledInterest(response?.data?.investorInfo == null)
            setIsEnabledFeedback(response?.data?.feedback == null)
            if (response?.data?.feedback !== null) {
                setOpenFeedbackPopup(false);
                setAlertMessage(`You have already submitted feedback for ${row?.original?.startup_name}. Please wait to hear back from the startup.`)
                setAlertHeading("Feedback")
                setShowAlert(true);
            }
            else {
                setOpenFeedbackPopup(true);
                setAlertMessage(null)
                setAlertHeading(null)
                setShowAlert(false);
            }
        }).catch(err => {
            // toast.error(<CustomToast message={err?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
            //     duration: 4000,
            //     position: "top-right",
            //     style: {
            //         padding: "15px 30px",
            //     },
            // });
            addToast(err?.response?.data?.message, "error")
        });


        setCurrentRow(row?.original);
    }

    const handleFeedbackPopupClose = () => {
        !Boolean(selectedPDF != null && selectedPDF?.length > 0) && setCurrentRow(null)
        setOpenFeedbackPopup(false)
    }

    const handleFeedbackSubmit = ({ row, values }) => {
        // console.log(row, "row")
        let request = {
            startup_id: row?.startup_id,
            investor_id: investor_id,
            ratings: {
                problem: values?.problem,
                market: values?.market,
                product: values?.product,
                team: values?.team,
                traction: values?.traction
            },
            investible: values?.invest,
            feedback: values?.feedback
        }
        // console.log(request, "request")
        saveFeedbackAsync(request).then(() => {
            refetchListing()
        })
        // setQueryParams(query);
        handleFeedbackPopupClose();
    }


    const handleShowInterestPopupOpen = ({ row }) => {
        let request = {
            startup_id: row?.original?.startup_id,
            investor_id: investor_id
        }

        // console.log(request, "row")
        FetchStatusAsync(request).then((response) => {
            // console.log(response,"resssss")
            setIsEnabledInterest(response?.data?.investorInfo == null)
            // setIsEnabledFeedback(response?.data?.feedback == null)
            if (response?.data?.investorInfo !== null) {
                setOpenShowInterestPopup(false);
                setAlertMessage(`You have already shown investment interest in ${row?.original?.startup_name}. Please wait to hear back from the startup.`)
                setAlertHeading("Investment Interest")
                setShowAlert(true);
            }
            else {
                setOpenShowInterestPopup(true);
                setAlertMessage(null)
                setAlertHeading(null)
                setShowAlert(false);
            }
        }).catch(err => {
            // toast.error(<CustomToast message={err?.response?.data?.message} style={{ padding: "0px 15px" }} closeIcon={true} />, {
            //     duration: 4000,
            //     position: "top-right",
            //     style: {
            //         padding: "15px 30px",
            //     },
            // });
            addToast(err?.response?.data?.message, "error")
        });


        setCurrentRow(row?.original);
    }

    const handleShowInterestPopupClose = () => {
        !Boolean(selectedPDF != null && selectedPDF?.length > 0) && setCurrentRow(null);
        setOpenShowInterestPopup(false)
    }

    const handleShowInterestPopupSubmit = ({ row, values }) => {
        // console.log(row, "row")
        let request = {
            startup_id: row?.startup_id,
            intrested_amount: values?.interested_amount
        }
        // console.log(request, "request");
        saveInterestAsync(request).then(() => {
            refetchListing()
        })
        handleShowInterestPopupClose();
    }

    const {
        mutateAsync: moveStartupToOnboardedAsync,
        status: moveStartupToOnboardedStatus,
        error: moveStartupToOnboardedError,
        isLoading: isMovingToOnboarded,
        data: moveStartupToOnboardedResponse,
    } = MoveStartupToOnboarded({ investor_id: investor_id });

    const {
        mutateAsync: inviteStartupAsync,
        status: inviteStartupStatus,
        error: inviteStartupError,
        isLoading: isInvitingStartup,
        data: inviteStartupResponse,
    } = InviteStartupPOST({ investor_id: investor_id });

    const [openOnboardedConfirmationPopup, setOpenOnboardedConfirmationPopup] = React.useState(false);

    const handleOnboardedConfirmationPopupClose = () => {
        setOpenOnboardedConfirmationPopup(false);
        setCurrentRow(null);
    }

    const handleOnboardedConfirmationPopupOpen = ({ row }) => {
        setOpenOnboardedConfirmationPopup(true);
        setCurrentRow(row?.original);
    }

    const handleMoveToOnboarded = ({ row, ...rest }) => {

        moveStartupToOnboardedAsync({
            "startup_id": row?._id,
            investor_id: investor_id,
            "is_onboarded": true,
            "comment": rest?.message
        }).then((response) => {
            // toast.success("Moved to On-Boarded");
            addToast("Moved to On-Boarded!", "success")
            refetchListing();
            handleOnboardedConfirmationPopupClose();
        }).catch((error) => {

        })

    }

    const [openRejectConfirmationPopup, setOpenRejectConfirmationPopup] = React.useState(false);

    const handleRejectConfirmationPopupClose = () => {
        setOpenRejectConfirmationPopup(false);
        setCurrentRow(null);
    }

    const handleRejectConfirmationPopupOpen = ({ row }) => {
        setOpenRejectConfirmationPopup(true);
        setCurrentRow(row?.original);
    }

    const handleSubmissionReject = ({ row }) => {
        // setCurrentRow(row);
        // console.log(row);
        // updateStartupStatusAsync({
        //     "startup_id": "66f285de9ce0f2c5615f20e5",
        //     "status_code": "rejected"
        // }).then((response) => {
        //     refetchListing();
        //     handleRejectConfirmationPopupClose();
        // }).catch((error) => {

        // })

        // updateStartupStatusAsync({
        //     "startup_id": row?.startup_id,
        //     "status_code": "rejected"
        // }).then((response) => {
        //     refetchListing();
        //     handleRejectConfirmationPopupClose();
        // }).catch((error) => {

        // })
    }

    const [openRequestDocumentsPopup, setOpenRequestDocumentsPopup] = React.useState(false);

    const handleRequestDocumentsPopupClose = () => {
        setOpenRequestDocumentsPopup(false);
        setCurrentRow(null);
    }

    const handleRequestDocumentsPopupOpen = ({ row }) => {
        setOpenRequestDocumentsPopup(true);
        setCurrentRow(row?.original);
    }

    const handleRequestDocuments = ({ row }) => {
        // setCurrentRow(row);
        // console.log(row);
        handleOnboardedConfirmationPopupClose();
    }

    const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const [openInviteStartupPopup, setOpenInviteStartupPopup] = React.useState(false);

    const handleInviteStartupPopupClose = () => {
        setOpenInviteStartupPopup(false);
    }

    const handleInviteStartupPopupOpen = () => {
        setOpenInviteStartupPopup(true);
    }

    const handleInviteStartup = async ({ payload }) => {
        // console.log(payload, "Please enter startup name");
        await inviteStartupAsync({
            payload, _id: investor_id
        }).then((response) => {
            refetchListing();
            handleInviteStartupPopupClose();
        }).catch((error) => {
            console.log(error?.message)
        })
    }

    const Actions = () => {
        return <>
            <B400 sx={{ display: 'flex', marginLeft: 'auto', background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", "& > .MuiButton-icon.MuiButton-startIcon": { marginRight: isMediumScreen ? 0 : '0.5rem', marginLeft: isMediumScreen ? 0 : '-0.25rem' } }} startIcon={<Add sx={{ width: 20, height: 20 }} />} onClick={() => handleInviteStartupPopupOpen()}>{isMediumScreen ? "" : "Invite"}</B400>
        </>
    }

    React.useEffect(() => {
        refetchListing();
    }, [reset, queryParams]);

    const isShortlisting = false;
    const isRejecting = false;
    const isRequestingDocuments = false;
    const stagesListing = startup_stages && startup_stages?.length > 0 ? startup_stages?.map(item => ({ label: item?.name, value: item?.name })) : []
    const categoriesListing = startup_categories && startup_categories?.length > 0 ? startup_categories?.map(item => ({ label: item?.name, value: item?.name })) : []
    const subCategoriesListing = startup_sub_categories && startup_sub_categories?.length > 0 ? startup_sub_categories?.map(item => ({ label: item?.sub_category, value: item?.sub_category })) : []
    // console.log(queryParams, subCategoriesListing, "queryParams")

    const FormattedData = useFormattedData(transformedData);



    const handleOpenPDFViewer = ({ row }) => {
        setCurrentRow(row);
        // console.log(currentRow,"currentRow")
        setSelectedPDF(row?.pitch_deck_path);
    }

    const handleClosePDFViewer = () => {
        setSelectedPDF(null);
        setCurrentRow(null);
    }

    const updateSector = (params) => {
        let removedSectorParamFromQuery = params;
        removedSectorParamFromQuery.sector && delete removedSectorParamFromQuery.sector;
        // Cookies.set("backrr_startups_query", JSON.stringify({ ...removedSectorParamFromQuery }));
        setQueryParams({ ...removedSectorParamFromQuery });
        setSector(null);
        setSearchStatus(false)
    }

    return (
        <>  <ConfirmationPopup open={openDeactivateSubscriptionPopup} handleClose={handleCloseDeactivateSubscription} handleSubmission={handleDeactivateSubscription} heading={"Deactivate Subscription"} subheading={"Are you sure you want to deactivate subscription for this startup?"} ActionText={"Confirm"} optional={false} messageLabel='Reason' currentRow={currentRow} isLoading={isDeactivatingSubscription} />
            {emailUpdateRow && <UpdateEmailPopup open={Boolean(emailUpdateRow)} handleClose={() => setEmailUpdateRow(null)} entity="startup" row={emailUpdateRow} onUpdated={refetchListing} />}
            {openActivateSubscriptionPopup && <CreateSubscription refetch={refetchListing} handleClose={handleCloseActivateSubscription} open={openActivateSubscriptionPopup} startupDetails={currentRow} />}
            {/* <AlertDialog open={showAlert} handleClose={() => { setShowAlert(false); setTimeout(() => { setAlertMessage(null); setAlertHeading(null) }, 1000) }} heading={alertHeading} subheading={alertMessage} /> */}
            <PDFView open={Boolean(selectedPDF != null && selectedPDF?.length > 0)} pdfUrl={selectedPDF} handleClose={handleClosePDFViewer} handleFeedbackPopupOpen={handleFeedbackPopupOpen} handleShowInterestPopupOpen={handleShowInterestPopupOpen} currentRow={currentRow} isEnabledFeedback={isEnabledFeedback} isEnabledInterest={isEnabledInterest} title={currentRow?.startup_name ? "Pitch Deck of " + currentRow?.startup_name : "Pitch Deck"} />
            {/* <InviteStartupPopup open={openInviteStartupPopup} handleClose={handleInviteStartupPopupClose} isSharingDocuments={false} refetchListing={refetchListing} handleSubmission={handleInviteStartup} isInvitingStartup={isInvitingStartup} /> */}
            <ModalComponent open={openFilter} onClose={handleFilterClose} style={{ maxWidth: 640, width: "100%" }}>
                <FilterPopup queryParams={queryParams} setQueryParams={setQueryParams} handleClose={handleFilterClose} handleSubmit={handleUpdateFilter} stage={stage} category={category} sector={sector} setStage={setStage} setCategory={setCategory} setSector={setSector} setProfileSource={setProfileSource} setProfileProgress={setProfileProgress}
                    uniqueCountryCity={transformedData?.uniqueCountryCity || []}
                    uniqueSignupUtmCampaigns={transformedData?.uniqueSignupUtmCampaigns || []}
                    uniqueSignupUtmSources={transformedData?.uniqueSignupUtmSources || []}
                    setLocationFilter={setLocationFilter}
                />
            </ModalComponent>
            <OnboardedConfirmationPopup open={openOnboardedConfirmationPopup} handleClose={handleOnboardedConfirmationPopupClose} handleSubmission={handleMoveToOnboarded} heading={"Move to On-Boarded"} ActionText={"Move"} subheading={"Are you sure you want to move to on-boarded startups?"} isLoading={isMovingToOnboarded} currentRow={currentRow} optional={false} />
            {/* <RejectedConfirmationPopup open={openRejectConfirmationPopup} handleClose={handleRejectConfirmationPopupClose} handleSubmission={handleSubmissionReject} heading={"Move to Rejected"} ActionText={"Reject"} subheading={"Are you sure you want to move to rejected startups?"} isLoading={false} currentRow={currentRow} optional={false} /> */}
            {/* <RequestDocumentsPopup open={openRequestDocumentsPopup} handleClose={handleRequestDocumentsPopupClose} handleSubmission={handleRequestDocuments} heading={"Request Documents"} ActionText={"Request"} subheading={"Are you sure you want to request documents for selected startup?"} isLoading={isRequestingDocuments} currentRow={currentRow} /> */}
            {/* <ModalComponent open={openFeedbackPopup} onClose={handleFeedbackPopupClose} style={{ maxWidth: 640, width: "100%" }}>
                <FeedbackPopup currentRow={currentRow} handleClose={handleFeedbackPopupClose} handleSubmit={handleFeedbackSubmit} />
            </ModalComponent> */}
            {/* <ModalComponent open={openShowInterestPopup} onClose={handleShowInterestPopupClose} style={{ maxWidth: 640, width: "100%" }}>
                <ShowInterestPopup currentRow={currentRow} handleClose={handleShowInterestPopupClose} handleSubmit={handleShowInterestPopupSubmit} />
            </ModalComponent> */}
            <ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}>
                <BreadcrumbHeader title={"Startups"}  Actions={() => <NeedHelpButton />} />
                <Grid container xs={12} padding={{ xs: "0 0rem 1rem 0rem", md: "0 0rem 2rem 0rem" }} justifyContent={"space-between"}>
                    <TabContext value={value}>
                        <Grid container xs={12} pt={0} pb={0} spacing={0} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
                            {/* <Grid item xs={10} lg={10}> */}
                            <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{ gap: "0.5rem" }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} mb={1}>
                                <Grid item xs={12} sm={12} md={12} lg={12} style={{ display: 'flex', height: 'min-content', alignItems: 'center', gap: "0.5rem", justifyContent: 'space-between' }}>
                                    <Grid item xs={12} md={4} display={"flex"} flexWrap={"nowrap"} container gap={1}>
                                        <CustomInputField
                                            autoComplete="off"
                                            sx={{
                                                marginBottom: 0,
                                                "& > .MuiFilledInput-root": {
                                                    borderColor: `${theme.palette.customColors.b50} !important`,
                                                    borderRadius: '8px'
                                                },
                                                ":disabled": {
                                                    bgcolor: theme.palette.customColors.b300,
                                                    color: theme.palette.customColors.whiteBG
                                                },
                                            }}
                                            // disabled={value === "subscribed"}
                                            fullWidth
                                            value={search}
                                            name={`search_${Math.random().toString(36).substring(7)}`}  // Set a random name attribute
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    // alert(e.target.value);
                                                    Cookies.set("search_backrr_startups", search);
                                                    refetchListing()
                                                    if (search) {
                                                        setSearchStatus(true)
                                                    }
                                                    setPage(1);
                                                    Cookies.set(paginationCookie, 1)
                                                }
                                            }}
                                            onChange={(event) => {
                                                setSearch(event.target.value);
                                                setSearchStatus(false)
                                            }}
                                            size="small"
                                            startAdornment={<>
                                                <Search sx={{ padding: "0rem 0rem 0rem 0.5rem" }} />
                                            </>}
                                            onClear={handleSearchReset}
                                            placeholder={'Search by name'}
                                        />
                                        {<Tooltip title="Filter" style={{
                                            visibility: value !== "subscribed" ? "visible" : "hidden"
                                        }} >
                                            <IconButton sx={{ marginLeft: "auto", display: { xs: 'flex', md: "flex" }, marginBlock: 'auto' }} onClick={() => handleFilterOpen()}>
                                                {Object.keys(queryParams)?.length > 0 ? <FilterAltRounded sx={{ color: theme?.palette?.customColors.indigo700 }} /> : <FilterAltOutlined />}
                                            </IconButton>
                                        </Tooltip>}
                                    </Grid>
                                    {/* <Grid item xs={1.5} md={6} container columnSpacing={2}>

                                    </Grid> */}
                                </Grid>
                                {/* <Grid item xs={0} sm={0} md={8} lg={9} display={{ xs: "none", md: "none" }} container spacing={1} alignItems={"center"}>
                                    <Grid item display={{ xs: "none", md: "block" }} width="25%">
                                        <Autocomplete
                                            disablePortal
                                            options={stagesListing}
                                            // disableClearable
                                            fullWidth
                                            // value={queryParams?.stage}
                                            value={Object.keys(queryParams)?.length && queryParams?.stage ? { label: queryParams?.stage, value: queryParams?.stage } : null}
                                            autoHighlight
                                            onChange={(e, newValue) => {
                                                // Cookies.set("backrr_startups_query", JSON.stringify({ ...queryParams, stage: newValue?.label }));
                                                setQueryParams({ ...queryParams, stage: newValue?.label }); setStage(newValue); setSearchStatus(false)
                                            }}
                                            renderInput={(params) => <CustomInputField variant={"outlined"} placeholder={"Stage"} {...params} sx={{ marginBottom: 0 }} className="filter-autocomplete" />}
                                        />
                                    </Grid>
                                    <Grid item display={{ xs: "none", md: "block" }} width="25%">
                                        <Autocomplete
                                            disablePortal
                                            // disableClearable
                                            options={categoriesListing}
                                            fullWidth
                                            // value={queryParams?.category}
                                            value={Object.keys(queryParams)?.length && queryParams?.category ? { label: queryParams?.category, value: queryParams?.category } : null}
                                            autoHighlight
                                            onChange={(e, newValue) => {
                                                // Cookies.set("backrr_startups_query", JSON.stringify({ ...queryParams, category: newValue?.label })); 
                                                setQueryParams({ ...queryParams, category: newValue?.label }); setCategory(newValue); setSearchStatus(false);
                                                setTimeout(() => {
                                                    updateSector({ ...queryParams, category: newValue?.label })
                                                }, 10)
                                            }}
                                            renderInput={(params) => <CustomInputField variant={"outlined"} placeholder={"Category"} {...params} sx={{ marginBottom: 0 }} className="filter-autocomplete" />}
                                        />
                                    </Grid>
                                    {startup_sub_categories && queryParams?.category && queryParams?.category != null && <Grid item display={{ xs: "none", md: "block" }} width="25%">
                                        <Autocomplete
                                            disablePortal
                                            // disableClearable
                                            options={subCategoriesListing}
                                            fullWidth
                                            // value={queryParams?.sub_category}
                                            value={Object.keys(queryParams)?.length && queryParams?.sector ? { label: queryParams?.sector, value: queryParams?.sector } : null}
                                            autoHighlight
                                            onChange={(e, newValue) => {
                                                // Cookies.set("backrr_startups_query", JSON.stringify({ ...queryParams, sector: newValue?.label })); 
                                                setQueryParams({ ...queryParams, sector: newValue?.label });
                                                setSector(newValue);
                                                setSearchStatus(false)
                                            }}
                                            renderInput={(params) => <CustomInputField variant={"outlined"} placeholder={"Sector"} {...params} sx={{ marginBottom: 0 }} className="filter-autocomplete" />}
                                        />
                                    </Grid>}
                                    <Grid item display={{ xs: "none", md: "block" }} width="25%">
                                        <Primary onClick={() => {

                                            if (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) {
                                                setSearch('')
                                                Cookies.set("search_backrr_startups", "");
                                                setQueryParams({})
                                                Cookies.set("backrr_startups_query", JSON.stringify({}));
                                                setStage(null)
                                                setCategory(null)
                                                setSector(null);
                                                // setStatus('')
                                                setReset(!reset)
                                            } else {
                                                Cookies.set("backrr_startups_query", JSON.stringify({ ...queryParams}));
                                                refetchListing()
                                            }
                                            setSearchStatus((oldVal) => !oldVal)
                                            setPage(1);
                                             Cookies.set(paginationCookie, 1);
                                        }} sx={{ padding: ".7rem 1.25rem", bgcolor: (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "#e9f5f8" : theme.palette.customColors.b300, ":hover": { bgcolor: (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "#e9f5f8" : theme.palette.customColors.b400 }, border: `0px solid ${(searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "black" : "inherit"}`, color: (searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? theme.palette.customColors.b300 : "white" }}>
                                            {(searchStatus && (search !== '' || Object.keys(queryParams)?.length > 0)) ? "Reset" : "Search"}
                                        </Primary>
                                    </Grid>
                                </Grid> */}
                            </Grid>
                            <Grid item xs={12} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} >
                                <Grid xs={12} container sx={{ bgcolor: 'white', borderRadius: '8px 8px 0 0', borderInline: `1px solid ${theme.palette.customColors.b50}`, borderBlock: `1px solid ${theme.palette.customColors.b50}` }}>
                                    <Grid width="100%">
                                        <CustomTabs
                                            variant="submenu"
                                            titleStyle={{ fontSize: '1rem' }}
                                            tabStyle={{ padding: { xs: '0.5rem 1rem 0rem' } }}
                                            sx={{ border: '0px solid black !important' }}
                                            bgColor={"transparent"}
                                            allowScrollButtonsMobile={true}
                                            tabFlexContainerSx={{ gap: { xs: '1rem', sm: '2.5rem', md: '3rem' } }}
                                            data={
                                                [...startupTabs?.map(item => {
                                                    return ({ ...item, label: `${item?.label} ${value === item?.value && transformedData?.count && transformedData?.count != 0 ? `(${transformedData?.count})` : ""}` })
                                                })]
                                            } value={value} handleChange={handleTabChange}
                                            isSmallScreen={isSmallScreen} className={classes.scrollTabs} key={"Tabs Tabs"} indicatorFullSize={false} />
                                    </Grid>
                                    {/* <Grid width="20%" pt={0.75} pr={1} marginLeft={"auto"}>
                                        <Actions />
                                    </Grid> */}
                                </Grid>
                            </Grid>
                            {/* { */}
                            {/* <Grid item xs={12} md={12} pt={"0 !important"} marginInline={"auto"} maxWidth={"100%"}> */}

                            {isLoadingStartupListing || isRefetchingStartupListing ?
                                <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingLeft: "2rem !important", paddingTop: "0rem !important", bgColor: theme.palette.customColors.yellow_bg }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                                    <Box className='skeleton' height={"100dvh"} sx={{ width: "auto", borderRadius: "0 0 8px 8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

                                    </Box>
                                </Grid> :
                                <Box width={"100%"} height="100%" paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                                    <AsyncTableListing
                                        columns={columns}
                                        // data={[]}
                                        tabValue={value}
                                        data={FormattedData}
                                        // title={"Investors"}
                                        // chipText={`${data?.length}${isSmallScreen ? "" : " Investors"}`}
                                        // actions={Actions}
                                        CustomLink={StartupLink}
                                        page={page}
                                        setPage={setPage}
                                        limit={limit}
                                        setLimit={setLimit}
                                        count={transformedData?.count}
                                        RowActions={RowActions}
                                        sx={{ borderRadius: '0 0 8px 8px', border: `1px solid ${theme.palette.customColors.b50}`, borderTop: 'none' }}
                                        refetchListing={refetchListing}
                                        noDataPlaceHolderImage={placeHolderImage}
                                        noDataTitle='No Startups'
                                        noDataSubTitle='It seems like there are no startups available at the moment.'
                                        maxHeight={transformedData?.count > 10 ? "calc(100dvh - 13rem)" : "calc(100dvh - 14rem)"}
                                        pageCookieName={paginationCookie}
                                    />
                                </Box>
                            }

                            {/* </Grid>} */}
                            {/* <Grid item xs={2} lg={2}> */}

                        </Grid>
                    </TabContext>
                </Grid>
            </ThemeBGWrapper>
        </>
    )
}

export default StartupsListing